import React from "react";
import { Link } from "react-router-dom";

const TestsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Доступные тесты
        </h1>

        <div className="grid md:grid-cols-1 gap-8">
          {/* Natural Intelligence Test */}
          <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-blue-500">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Тест по природным интеллектам
            </h2>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">
                <strong>Описание:</strong> Каждый человек рождается с врожденными склонностями, 
                которые усиливаются нашим окружением — особенно на ранних стадиях жизни. 
                Эти черты влияют на то, как мы действуем и к какому виду деятельности нас тянет.
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Количество вопросов:</strong> 81
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Система оценки:</strong> От 0 до 2 (включая десятичные значения)
              </p>
              <p className="text-gray-600 mb-4">
                <strong>Время прохождения:</strong> 15-20 минут
              </p>
            </div>
            {/* <div className="mb-6 p-4 bg-yellow-50 rounded-md">
              <h3 className="font-semibold text-yellow-800 mb-2">Инструкция:</h3>
              <p className="text-yellow-700 text-sm">
                Отметьте номера утверждений цифрами от 0 до 2.
                Если полностью согласны, что вам подходит утверждение, например, 100% = 1, 
                если частично ставим меньше 100% (например, 37% = 0.37, 12% = 0.12, 83% = 0.83 и тд), 
                если даже «во сне» вы так сделаете, то есть больше, чем уверены (самоуверены) в данном предложении, 
                возможно ответить свыше 100%, предельная величина до 200% = 2 (например, 118% = 1.18, 143% = 1.43, 179% = 1.79 и тд) не согласны 0. 
                Проставьте пожалуйста объективный показатель по каждому пункту для получения точного результата.
              </p>
            </div> */}
            <Link
              to="/tests/natural-intelligence"
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors inline-block"
            >
              Начать тест
            </Link>
          </div>

          {/* Intelligence Types Test */}
          <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-green-500">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Анкета по типам интеллекта
            </h2>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">
                <strong>Описание:</strong> Анкета по типам интеллекта позволяет выявить вашу 
                склонность к тому или иному типу деятельности, что может помочь вам в выборе 
                будущей профессии. Анкета основана на взглядах о структуре интеллекта, 
                изложенных в теории Г. Гарднера.
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Количество вопросов:</strong> 90
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Система оценки:</strong> Да/Нет
              </p>
              <p className="text-gray-600 mb-4">
                <strong>Время прохождения:</strong> 10-15 минут
              </p>
            </div>
            {/* <div className="mb-6 p-4 bg-green-50 rounded-md">
              <h3 className="font-semibold text-green-800 mb-2">Типы интеллекта по Гарднеру:</h3>
              <ul className="text-green-700 text-sm list-disc list-inside">
                <li>Телесно-кинестетический</li>
                <li>Пространственный</li>
                <li>Межличностный</li>
                <li>Музыкальный</li>
                <li>Лингвистический</li>
                <li>Логико-математический</li>
                <li>Внутриличностный</li>
                <li>Натуралистический</li>
              </ul>
            </div> */}
            <Link
              to="/tests/intelligence-types"
              className="bg-green-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-green-700 transition-colors inline-block"
            >
              Начать анкету
            </Link>
          </div>

          {/* Belbin Test */}
          <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-purple-500">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Анкета по Белбину
            </h2>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">
                <strong>Описание:</strong> Тест командных ролей по Белбину поможет определить 
                вашу предпочтительную роль в команде и понять, как вы можете наиболее эффективно 
                взаимодействовать с другими участниками.
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Количество блоков:</strong> 8
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Система оценки:</strong> Распределение 10 баллов между 8 утверждениями в каждом блоке
              </p>
              <p className="text-gray-600 mb-4">
                <strong>Время прохождения:</strong> 10-15 минут
              </p>
            </div>
            {/* <div className="mb-6 p-4 bg-purple-50 rounded-md">
              <h3 className="font-semibold text-purple-800 mb-2">Командные роли по Белбину:</h3>
              <ul className="text-purple-700 text-sm list-disc list-inside">
                <li>Исполнитель • Координатор • Формирователь • Генератор идей</li>
                <li>Исследователь ресурсов • Оценщик • Коллективист • Доводчик</li>
              </ul>
            </div> */}
            <Link
              to="/tests/belbin"
              className="bg-purple-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors inline-block"
            >
              Начать тест
            </Link>
          </div>

          {/* ORS Test */}
          <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-red-500">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Тест на определение ОРС
            </h2>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">
                <strong>Описание:</strong> Тест на определение ведущей репрезентативной системы 
                (ОРС) поможет выявить, какой канал восприятия информации является для вас 
                доминирующим: визуальный, аудиальный, кинестетический или дигитальный.
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Количество вопросов:</strong> 15 + 4 дополнительных
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Система оценки:</strong> Выбор одного наиболее подходящего варианта
              </p>
              <p className="text-gray-600 mb-4">
                <strong>Время прохождения:</strong> 5-10 минут
              </p>
            </div>
            {/* <div className="mb-6 p-4 bg-red-50 rounded-md">
              <h3 className="font-semibold text-red-800 mb-2">Репрезентативные системы:</h3>
              <ul className="text-red-700 text-sm list-disc list-inside">
                <li><strong>V (Визуальная)</strong> - восприятие через зрение, образы</li>
                <li><strong>A (Аудиальная)</strong> - восприятие через слух, звуки</li>
                <li><strong>K (Кинестетическая)</strong> - восприятие через ощущения, движения</li>
                <li><strong>D (Дигитальная)</strong> - восприятие через логику, факты</li>
              </ul>
            </div> */}
            <Link
              to="/tests/ors"
              className="bg-red-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-red-700 transition-colors inline-block"
            >
              Начать тест
            </Link>
          </div>

          {/* Subtype Test */}
          <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-orange-500">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Тест на подтип личности (мотивация)
            </h2>
            <div className="mb-6">
              <p className="text-gray-600 mb-3">
                <strong>Описание:</strong> Тест поможет определить ваш доминирующий инстинктивный 
                подтип и понять, какая из трех базовых потребностей является для вас наиболее 
                важной в жизни.
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Количество вопросов:</strong> 40
              </p>
              <p className="text-gray-600 mb-3">
                <strong>Система оценки:</strong> Выбор одного из трех вариантов
              </p>
              <p className="text-gray-600 mb-4">
                <strong>Время прохождения:</strong> 8-12 минут
              </p>
            </div>
            {/* <div className="mb-6 p-4 bg-orange-50 rounded-md">
              <h3 className="font-semibold text-orange-800 mb-2">Инстинктивные подтипы:</h3>
              <ul className="text-orange-700 text-sm list-disc list-inside">
                <li><strong>SP (Самосохранение)</strong> - фокус на безопасности и комфорте</li>
                <li><strong>SX (Сексуальный)</strong> - фокус на интенсивности и привлекательности</li>
                <li><strong>SO (Социальный)</strong> - фокус на группе и социальных связях</li>
              </ul>
            </div> */}
            <Link
              to="/tests/subtype"
              className="bg-orange-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-orange-700 transition-colors inline-block"
            >
              Начать тест
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestsPage;